





























































































































import settings from '@/settings'
import n from '@/utils/notifications'
import t from '@/utils/tools'
import q from '@/graphql/query'
import m from '@/graphql/mutation'
import af from '@/utils/authorized_formats'
import element_cell from '@/components/vpe/element_cell'
import vpe_table_dialog from '@/components/vpe/vpe_table_dialog'

export default {
    name: 'vpe_table'

    components: { element_cell, vpe_table_dialog }

    props:
        component:
            required: true
        date:
            required: true
        vpc_set:
            required: true

    watch:
        date: (new_one, old_one)->
            if new_one != old_one
                @get_vp_custom_vp_dated_set()

        vpc_set: (new_one, old_one)->
            if new_one != old_one
                @vpe_table_key = +new Date()

    data: ()->
        errors: {}
        loading: true
        search: ''
        toggle_dialog: false
        counted_users: []
        vp_userjob_set: []
        vp_custom_vp_dated_set: []
        vpc_dated_uid_set: []
        current_index: null
        max_filesize: af['vpe']['file']['max_filesize']/1024/1024
        authorized_formats: af['vpe']['file']['authorized_formats']
        evp_state_classes: @$store.state.evp_state_classes
        vpe_table_key: ''
        refuse_dialog_visible: false
        pre_send_dialog_visible: false
        reset_dialog_visible: false
        selected_vpduj: {}
        selection_set: []
        uj_selection_set: []
        selected_line: {
            user: { 
                user_info: {
                    lastname: ''
                    firstname: ''
                }    
            }
            job: {
                name: ''
            }
            vp_dated_user_job: {
                reason: ''
            }
        }
        validate_line: true
        col_to_reset: []

    computed:
        data_filtered: ()->
            self = @
            data = @vp_userjob_set.filter (x)->
                start_date = self.date_formatter(x.start)

                !self.search || x.user.user_info.lastname.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,"").includes(self.search.toLowerCase()) || x.user.user_info.lastname.toLowerCase().includes(self.search.toLowerCase())\
                || start_date.includes(self.search.toLowerCase()) \
                || x.user.user_info.firstname.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,"").includes(self.search.toLowerCase()) || x.user.user_info.firstname.toLowerCase().includes(self.search.toLowerCase())\
                || x.job.name.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,"").includes(self.search.toLowerCase()) || x.job.name.toLowerCase().includes(self.search.toLowerCase())
            @users_counting(data)
            @vpe_table_key = +new Date()
            return data

        uj_selection_set_filtered: ()->
            uj_selection_set_filtered = @uj_selection_set.filter (x)->
                # console.log "FILTERED", x
                if x.vp_dated_user_job.state.slug in ['refuse', 'en_cours']
                    return x
            return uj_selection_set_filtered

        vp_custom_vp_dated_set_filtered: ()->
            return @vp_custom_vp_dated_set.filter (x)-> return x.vp_custom.editable_by_all

        has_edit_all_cells_right: ()->
            return @has_access_right("vpe_edit_all_cells")

        has_vpe_send_right: ()->
            ret = true
            if @component == "company"
                ret = @has_access_right("vpe_send")
            return ret

        evp_validation_button_text: ()->
            ret = "Clore..."
            if @$store.getters.current_company.has_accounting_software
                ret = "Envoyer..."
            if @component == "users"
                ret = "Transmettre mes EVP"
            return ret

        select_col_name: ()->
            text = "Sélection pour clôture"
            if @$store.getters.current_company.has_accounting_software
                text = "Sélection pour envoi"
            return text

        pre_send_dialog_text: ()->
            ret = "Clore"
            if @$store.getters.current_company.has_accounting_software
                ret = "Envoyer"
            return ret

        end_status_text: ()->
            text = "clos le"
            if @$store.getters.current_company.has_accounting_software
                text = "envoyé en compta le"
            return text

        evp_validation_button_disabled: ()->
            ret = @vp_custom_vp_dated_set.length == 0
            if @component == "users"
                status = true
                for item in @vp_userjob_set
                    if item.vp_dated_user_job.state.slug not in ['en_cours', 'refuse'] or item.vp_dated_user_job.sent
                        status = status and false
                        break
                ret = ret or !status
            else
                if !@$store.getters.current_company.has_accounting_software
                    status = true
                    for item in @vp_userjob_set
                        if item.vp_dated_user_job.sent
                            status = status and false
                            break
                    ret = ret or !status
            return ret

    methods:
        date_formatter: t.date_formatter
        has_access_right: t.has_access_right

        col_highlight: ({row, column, rowIndex, columnIndex})->
            col_count = @vp_custom_vp_dated_set.length + 5
            # console.log "COL HIGHLIGHT ", column, columnIndex
            if columnIndex == col_count
                return "col-highlight"

        pop_style: (reason)->
            style = "font-size:16px; margin-left:4px;"
            if reason.length == 0
                style += " display:none;"
            return style

        # check: (new_value)->
        #     console.log "CHECK", new_value
        #     console.log "CHECK", @selection_old_set
        #     return

        human_date: (date)->
            return new Date(date).toLocaleDateString('fr-FR', {month:'2-digit', year:'2-digit'})

        handle_selection_change: (selection_set)->
            @selection_set = selection_set
            # console.log "SELECTION CHANGE", @selection_set
            return

        get_errors: (fieldName)->
            ret = null
            if @errors[fieldName]?
                ret = @errors[fieldName][0]
            return ret

        accept_line: (vpduj)->
            # console.log "ACCEPT LINE"
            self = @
            @$confirm("Êtes-vous sûr·e de vouloir valider cette ligne ?", 'Confirmation', {
                confirmButtonText: 'Oui',
                cancelButtonText: 'Annuler'
                })
                .then ()->
                    for state in self.$store.state.state_choice_set
                        if state.slug == "accepte"
                            vpduj.state = t.deep_copy(state)
                            break
                    self.save_vp_dated_user_job(vpduj, false, true)
                .catch (cancel)->
                    return
            return

        refuse_line: (vpduj)->
            # console.log "REFUSE LINE"
            @refuse_dialog_visible = true
            @selected_vpduj = t.deep_copy(vpduj)
            return

        pre_reset_line: (row)->
            # console.log "RESET LINE ROW", row
            @reset_dialog_visible = true
            @selected_line = t.deep_copy(row)
            @validate_line = true
            return

        reset_line: ()->
            self = @
            # console.log "COL TO RESET", @col_to_reset
            # console.log "SELECTED LINE", @selected_line
            @$http.post(settings.reset_vpduj, {"company_uid": self.$store.getters.current_company.uid, "vpduj_uid": self.selected_line.vp_dated_user_job.uid, "vp_custom_vp_dated_uid_set": @col_to_reset, "validate_line": self.validate_line, "reason": self.selected_line.vp_dated_user_job.reason})
            .then (resp)->
                if resp.body.status == "ok"
                    self.refresh()
                    self.cancel_reset_dialog()
                else
                    n.error("vpe_table: reset_line: then", resp.body.message)
            return

        cancel_refuse_dialog: ()->
            # console.log 'REFUSE CANCEL'
            @refuse_dialog_visible = false
            @selected_vpduj = {}
            @errors = {}
            return

        cancel_pre_send_dialog: ()->
            # console.log 'CANCEL PRE SEND'
            @selection_set = []
            @uj_selection_set = []
            @pre_send_dialog_visible = false
            return

        cancel_reset_dialog: ()->
            @reset_dialog_visible = false
            @selected_line = {
                user: { 
                    user_info: {
                        lastname: ''
                        firstname: ''
                    }    
                }
                job: {
                    name: ''
                }
                vp_dated_user_job: {
                    reason: ''
                }
            }
            @validate_line = true
            @col_to_reset = []
            return

        vpduj_pre_save: ()->
            # console.log 'PRE SAVE'
            @save_vp_dated_user_job(@selected_vpduj, true, true)
            return

        sending: (uj_selection_set)->
            # console.log "UJ", uj_selection_set
            @pre_send_dialog_visible = false
            @$router.push({name:"company_variable_payroll_sending", params:{uj_set:uj_selection_set, vp_custom_vp_dated_set:@vp_custom_vp_dated_set, date:@date}})
            .catch((err)-> {})
            return

        evp_validation: ()->
            self = @
            if @component == "users"
                now = Date.now()
                date_month = new Date(@date)
                # console.log "USERS EVP_VALIDATION", now > date_month, now < date_month
                @$confirm("Êtes-vous sûr·e de vouloir transmettre vos EVP ?", 'Confirmation', {
                    confirmButtonText: 'Oui',
                    cancelButtonText: 'Annuler'
                    })
                    .then ()->
                        m.run('pass_vp_dated_user_job', [self.vp_userjob_set.map (x)-> x.vp_dated_user_job.uid])
                        .then (resp)->
                            # console.log "EVP_VALIDATION", resp.body.data.pass_vp_dated_user_job_mutation
                            if resp.body.data.pass_vp_dated_user_job_mutation.ok
                                # console.log "EVP_VALIDATION"
                                if resp.body.data.pass_vp_dated_user_job_mutation.message == "next_month"
                                    self.$alert("Paiement le mois prochain car date butoir dépassée", 'Attention', {
                                        confirmButtonText: 'OK'
                                    })
                                self.get_vp_userjob_set()
                            else
                                n.gql_error("vpe_table: pass_vp_dated_user_job_set: then", resp.body.data.pass_vp_dated_user_job_mutation.message)
                        .catch (resp)->
                            n.catch_error(resp, "vpe_table: evp_validation()")
                    .catch (cancel)->
                        return
            else if @component == "company"
                if @selection_set.length == 0
                    n.warning("Vous devez cocher des lignes afin de les envoyer.")
                    return

                open_pre_send_dialog = false
                @get_vp_userjob_set()
                .then ()->
                    # console.log "COMPANY EVP_SENDING"
                    selection_uid_set = self.selection_set.map (x)->
                        return x.vp_dated_user_job.uid
                    # console.log "SELECTION_UID_SET", selection_uid_set
                    self.uj_selection_set = []
                    for item in self.vp_userjob_set
                        tmp_item = t.deep_copy(item)
                        if item.vp_dated_user_job.uid in selection_uid_set
                            self.uj_selection_set.push(tmp_item)
                            if item.vp_dated_user_job.state.slug != 'accepte' and !open_pre_send_dialog
                                open_pre_send_dialog = true
                    # console.log "UJ SELECTION SET", self.uj_selection_set
                    if open_pre_send_dialog
                        self.pre_send_dialog_visible = true
            return

        can_edit: (vpduj)->
            ret = false
            if @component == "company"
                ret = @has_access_right("vpe_edit") and vpduj.state.slug in ['en_cours', 'transmis']
            else
                ret = @has_access_right("vpe_self_edit") and vpduj.state.slug in ['en_cours', 'refuse']
            # console.log "CAN EDIT", ret, vpduj.sent
            return ret and !vpduj.sent

        can_reset: (vpduj)->
            return @has_access_right("vpe_send") and !vpduj.sent

        download_file: (vp_dated_user_job)->
            url = settings.backend_url+vp_dated_user_job.file_url
            filename = vp_dated_user_job.file_url.split('/').pop()
            t.download_file(url, filename)
            return

        upload_triggered: (index)->
            # console.log "upload_triggered", index
            @current_index = index
            return

        handle_file_remove: (file, fileList)->
            # console.log "HANDLE FILE REMOVE", file.name
            for index, el of @vp_userjob_set
                if el.vp_dated_user_job.file_tmp_uid? and el.vp_dated_user_job.file_tmp_uid == file.uid
                    @vp_userjob_set[index].vp_dated_user_job.file_data = ''
                    @vp_userjob_set[index].vp_dated_user_job.file_name = ''
                    @vp_userjob_set[index].vp_dated_user_job.file_tmp_uid = ''
                    @vp_userjob_set[index].vp_dated_user_job.file_url = ''
                    @save_vp_dated_user_job(@vp_userjob_set[index].vp_dated_user_job, null, false)
                    break
            fileList.splice(0,0)
            return

        handle_file_change: (file, fileList)->
            self = @
            @$confirm("Vous allez saisir un justificatif : vous devez le conserver au moins 2 mois dans le cas d'un litige ou d'un refus.", 'Confirmation', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Annuler'
                })
                .then ()->
                    # console.log "CONFIRM OK", self.current_index
                    is_good_ext = file.raw.type in af['vpe']['file']['mime_types']
                    is_good_size = file.size < af['vpe']['file']['max_filesize']

                    if !is_good_ext
                        n.file_error('Erreur', 'Le fichier doit être de type '+@authorized_formats+'.')
                        fileList.pop()
                        return
                    if !is_good_size
                        n.file_error('Erreur', 'Le fichier ne peut pas excéder '+@max_filesize+'Mo.')
                        fileList.pop()
                        return

                    if fileList.length > 1
                        fileList.splice(0,1)
                    reader = new FileReader()
                    reader.onload = (e)->
                        # console.log 'E', e
                        self.vp_userjob_set[self.current_index].vp_dated_user_job.file_data = e.target.result
                        self.vp_userjob_set[self.current_index].vp_dated_user_job.file_name = file.name
                        self.vp_userjob_set[self.current_index].vp_dated_user_job.file_tmp_uid = file.uid
                        self.save_vp_dated_user_job(self.vp_userjob_set[self.current_index].vp_dated_user_job, null, false)
                    reader.readAsDataURL(file.raw)
                .catch (cancel)->
                    fileList.pop()
                    return
            return

        delete_file: (index)->
            # console.log "DELETE ROW FILE", index
            self = @
            @$confirm("Êtes-vous sûr·e de vouloir supprimer ce fichier ?", 'Confirmation', {
                confirmButtonText: 'Oui',
                cancelButtonText: 'Annuler'
                })
                .then ()->
                    self.vp_userjob_set[index].vp_dated_user_job.file_url = ''
                    self.save_vp_dated_user_job(self.vp_userjob_set[index].vp_dated_user_job, null, false)
                .catch (cancel)->
                    return
            return

        save_vp_dated_user_job: (vpduj, refuse, refresh)->
            # console.log "SAVE_VP_DATED_USER_JOB", refuse, not refuse
            self = @
            for state in @$store.state.state_choice_set
                if state.slug == "refuse" and refuse is not null and refuse
                    vpduj.state = t.deep_copy(state)
                    break
                else if state.slug == "accepte" and refuse is not null and not refuse
                    vpduj.state = t.deep_copy(state)
                    break
            m.run('save_vp_dated_user_job', [vpduj, @component])
            .then (resp)->
                # console.log "SAVE VPDUJ RET ", resp.body.data.vp_dated_user_job_form_mutation.form_ret
                if resp.body.data.vp_dated_user_job_form_mutation.form_ret == 'failed'
                    return n.access_denied()
                if resp.body.data.vp_dated_user_job_form_mutation.errors.length > 0
                    self.errors = resp.body.data.vp_dated_user_job_form_mutation.errors.reduce(
                        (acc, el)->
                            acc[el.field] = el.messages
                            return acc
                    ,{})
                    n.form_error()
                else
                    n.success()
                    if resp.body.data.vp_dated_user_job_form_mutation.form_ret != '' and self.current_index != null
                        # console.log "CHANGE FILE URL ", self.current_index
                        self.vp_userjob_set[self.current_index].vp_dated_user_job.file_url = resp.body.data.vp_dated_user_job_form_mutation.form_ret
                        self.vp_userjob_set[self.current_index].vp_dated_user_job.file_data = ''
                        self.vp_userjob_set[self.current_index].vp_dated_user_job.file_name = ''
                        self.vp_userjob_set[self.current_index].vp_dated_user_job.file_tmp_uid = ''
                        # console.log "CHANGE FILE URL ", self.vp_userjob_set[self.current_index].vp_dated_user_job.file_url
                    if refuse
                        for index, item of self.vp_userjob_set
                            if item.vp_dated_user_job.uid == self.selected_vpduj.uid
                                item.vp_dated_user_job = t.deep_copy(self.selected_vpduj)
                                break
                    self.cancel_refuse_dialog()
                    # if refresh
                    #     self.refresh(false)
            .catch (resp)->
                n.catch_error(resp, "vpe_table: save_vp_dated_user_job()")
                self.cancel_refuse_dialog()
                self.refresh(false)
            return

        element_set_picker: (vp_element_set_group, vpc_vpd_uid)->
            ret = []
            for el_set in vp_element_set_group
                if el_set.vp_custom_vp_dated_uid == vpc_vpd_uid
                    ret = el_set.element_set
                    break 
            return ret

        dialog_title: (row, vpc)->
            return vpc.name+" - "+row.user.user_info.lastname+" "+row.user.user_info.firstname+" - "+row.job.name

        span_method: ({ row, column, rowIndex, columnIndex })->
            if columnIndex == 0
                user_str = row.user.user_info.lastname+" "+row.user.user_info.firstname
                if rowIndex == 0
                    return [@counted_users[user_str], 1]
                else
                    if user_str != @data_filtered[rowIndex - 1]['user']['user_info']['lastname']+" "+@data_filtered[rowIndex - 1]['user']['user_info']['firstname']
                        return [@counted_users[user_str], 1]
                    else
                        return [0, 0]
            return

        users_counting: (datas)->
            @counted_users = datas
                .map (x)->
                    return x.user.user_info.lastname+" "+x.user.user_info.firstname
                .reduce (acc, user_str)->
                    if user_str in Object.keys(acc)
                        acc[user_str] += 1
                    else
                        acc[user_str] = 1
                    return acc
                , {}
            # console.log "USERS_COUNTING", @counted_users
            return

        manage_vpc_set: ()->
            # console.log "MANAGE VPC SET"
            @toggle_dialog = !@toggle_dialog
            return

        error_element_set: ()->
            @get_vp_userjob_set()
            return

        refresh: (emit)->
            # console.log "REFRESH", emit
            @loading = true
            if emit
                @$emit('change-vpc')
            @get_vp_custom_vp_dated_set()
            return

        delete_vp_custom_vp_dated: (vpc_vpd, refresh)->
            # console.log "DELETE VPC VPD", vpc_vpd.uid, refresh
            self = @
            @$confirm("Êtes-vous sûr·e de vouloir supprimer cette colonne ainsi que toutes les valeurs qui lui sont reliées pour le mois sélectionné ?", 'Confirmation', {
                confirmButtonText: 'Oui',
                cancelButtonText: 'Annuler'
                })
                .then ()->
                    m.run('delete_vp_custom_vp_dated', [vpc_vpd.uid])
                    .then (resp)->
                        # console.log "DELETE VPC VPD", resp.body.data.vp_custom_vp_dated_deletion
                        if resp.body.data.vp_custom_vp_dated_deletion.ok
                            if refresh
                                self.refresh(false)
                            else
                                self.vpc_dated_uid_set = self.vpc_dated_uid_set.filter (x)-> return x != vpc_vpd.vp_custom.uid
                        else
                            n.gql_error("vpe_table: delete_vp_custom_vp_dated: then", resp.body.data.vp_custom_vp_dated_deletion.message)
                    .catch (resp)->
                        n.catch_error(resp, "vpe_table: delete_vp_custom_vp_dated()")
                .catch (cancel)->
                    return

        get_vp_userjob_set: ()->
            self = @
            q.run('get_vp_userjob_set', [@$store.getters.current_company.uid, @date, @component, @date])
            .then (resp)->
                if resp.body.errors? and resp.body.errors.length > 0
                    for e in resp.body.errors
                        n.gql_error("vpe_table: get_vp_userjob_set: then", e.message)
                else
                    # console.log "GET_VP_USERJOB_SET : ", resp.body.data.vp_userjob_set
                    if resp.body.data.vp_userjob_set != null
                        self.vp_userjob_set = resp.body.data.vp_userjob_set
                    self.loading = false
                    self.vpe_table_key = +new Date()
            .catch (resp)->
                n.catch_error(resp, "vpe_table: get_vp_userjob_set()")
        
        get_vp_custom_vp_dated_set: ()->
            self = @
            @loading = true
            q.run('get_vp_custom_vp_dated_set', [@$store.getters.current_company.uid, @date])
            .then (resp)->
                if resp.body.errors? and resp.body.errors.length > 0
                    for e in resp.body.errors
                        n.gql_error("vpe_table: get_vp_custom_vp_dated_set: then", e.message)
                else
                    # console.log "GET_VP_CUSTOM_VP_DATED_SET : ", resp.body.data.vp_custom_vp_dated_set
                    if resp.body.data.vp_custom_vp_dated_set != null
                        self.vp_custom_vp_dated_set = resp.body.data.vp_custom_vp_dated_set
                        self.vpc_dated_uid_set = resp.body.data.vp_custom_vp_dated_set.map (x)-> return x.vp_custom.uid
                        # console.log "VPC DATED UID SET", self.vpc_dated_uid_set
                        self.get_vp_userjob_set()
            .catch (resp)->
                n.catch_error(resp, "vpe_table: get_vp_custom_vp_dated_set()")
            
    beforeMount: ()->
        # console.log "beforeMount vpe_table", @$store.getters.current_company
        @get_vp_custom_vp_dated_set()
}
